// @flow

import { useEffect } from 'react';
import { useIncomingPayment, usePendingIncomingPayment, getSafePaymentTypeCode, getSafePaymentType } from '@tectonics/prs/incoming-payment';
import { isVoucher } from '@tectonics/prs/payment-method';
import { useAnalyticsContext } from './context';
import { sendGA4VoucherGeneratedOnce } from '@tectonics/controller/ga4';

export function useSendVoucherGenerateEvent(ready: bool) {
  const incomingPayment = useIncomingPayment();
  const paymentTypeCode = getSafePaymentTypeCode(incomingPayment);
  const analytics = useAnalyticsContext();

  useEffect(() => {
    if (ready && incomingPayment.status === 'PE' && isVoucher(paymentTypeCode)) {
      analytics.eventOnce('voucherGenerate', incomingPayment);
      sendGA4VoucherGeneratedOnce(incomingPayment);
    }
  }, [ready, incomingPayment, paymentTypeCode]);
}

export function useSendPendingEvent(ready: bool) {
  const incomingPayment = usePendingIncomingPayment();
  const analytics = useAnalyticsContext();

  useEffect(() => {
    if (ready) {
      if (isVoucher(getSafePaymentTypeCode(incomingPayment))) {
        analytics.eventOnce('voucherGenerate', incomingPayment);
        sendGA4VoucherGeneratedOnce(incomingPayment);
      } else if (getSafePaymentType(incomingPayment) === 'creditcard') {
        analytics.eventOnce('purchaseAttempt', incomingPayment);
      }
    }
  }, [ready, incomingPayment]);
}
